import React, { Children, Fragment } from 'react';
import { IconBaseProps } from 'react-icons';

import {
  Box,
  Flex,
  Text,
  HStack,
  SystemProps,
  Skeleton,
} from '@chakra-ui/react';

interface HighlightsProps {
  data: HighlightData[];
  justify?: SystemProps['justifyContent'];
  wrap?: boolean;
  enableLoading?: boolean;
  isLoading?: boolean;
  pl?: number;
  onlyIcon?: boolean;
}

interface HighlightData {
  label: string;
  icon: React.ComponentType<IconBaseProps>;
  text?: string;
  children?: React.ReactNode;
  length?: number;
  // width do Skeleton
  widthSke?: string;
}

const Highlights: React.FC<HighlightsProps> = ({
  data,
  justify,
  enableLoading = false,
  isLoading,
  wrap = false,
  pl = 4,
  onlyIcon = false,
}) => {
  return (
    <HStack
      spacing={[0, '100px']}
      flexDir={['column', 'row']}
      align={['start', 'center']}
      wrap={wrap ? 'wrap' : 'nowrap'}
      justify={justify || 'start'}
      mb={['6px', '10px']}
      pl={pl}
    >
      {data.map((high, i) => {
        const num = i + 1;

        return (
          <Fragment key={num}>
            {(!enableLoading ||
              (enableLoading && (isLoading || !!high?.text))) && (
              <Box maxWidth="400px" mb={[4, 0]} pl={4}>
                <Flex w="full" alignItems="center" mb={2}>
                  {high?.icon && (
                    <Box as={high?.icon} size="20px" mr={4} minW="20px" />
                  )}
                  {!onlyIcon && <Text fontWeight={700}>{high?.label}</Text>}
                </Flex>
                <>
                  {enableLoading && isLoading ? (
                    <Skeleton width={high?.widthSke || '140px'} height="30px" />
                  ) : (
                    high.text && <Text fontSize={20}>{high.text}</Text>
                  )}

                  {high?.children && high?.children}
                </>
              </Box>
            )}
          </Fragment>
        );
      })}
    </HStack>
  );
};

export default Highlights;
